// tslint:disable-next-line:no-implicit-dependencies
import {Subject, Subscription} from "rxjs";

export interface WidgetEvent {
    from?: any;
    type: string;
    data?: any;
}

export class WidgetController {
    private sub: Subject<WidgetEvent>;

    constructor() {
        this.sub = new Subject<any>();
    }

    public listen(listener: (event: WidgetEvent) => void): Subscription {
        return this.sub.subscribe(listener);
    }

    public dispose(): void {
        this.sub.unsubscribe();
    }

    public addEvent(newEvent: WidgetEvent): void {
        this.sub.next(newEvent);
    }
}
